export default {"src":"/_next/static/media/steem-logo.9688228a.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};